import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { loadAll as loadTrackingPixels } from './utils/tracking/bootstrap';
import { captureAttributionFromUrl } from './utils/attribution';
import { captureOpenSearchFromUrl } from './utils/openSearchDeepLink';
import 'antd/dist/reset.css'
import 'nprogress/nprogress.css'
import './index.css'

captureAttributionFromUrl();
// Capture ?open_search=1 before React renders — the catalog pages strip it from
// the URL before CatalogSearch mounts. CatalogSearch consumes this on mount.
captureOpenSearchFromUrl();
loadTrackingPixels();

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
